import { COL_COUNT } from './const';
import _ from 'lodash';
import { dbget } from '../HOME/utils';

export const palette = {
  1: { background: '  #95B0CC', foreground: 'black' },
  2: { background: '  #2A6099', foreground: 'white' },
  10: { background: ' #FFFF80', foreground: 'black' },
  11: { background: ' #8AC273', foreground: 'black' },
  12: { background: ' #158466', foreground: 'white' },
  20: { background: ' #FFFF00', foreground: 'black' },
  21: { background: ' #80D41A', foreground: 'black' },
  22: { background: ' #00A933', foreground: 'white' },
  100: { background: '#FF8080', foreground: 'black' },
  101: { background: '#AA5886', foreground: 'white' },
  102: { background: '#55308D', foreground: 'white' },
  110: { background: '#FFA040', foreground: 'black' },
  111: { background: '#9C744A', foreground: 'white' },
  112: { background: '#384853', foreground: 'white' },
  120: { background: '#FFC000', foreground: 'black' },
  121: { background: '#8D900D', foreground: 'white' },
  122: { background: '#1A611A', foreground: 'white' },
  200: { background: '#FF0000', foreground: 'white' },
  201: { background: '#C00040', foreground: 'white' },
  202: { background: '#800080', foreground: 'white' },
  210: { background: '#FF6400', foreground: 'black' },
  211: { background: '#AD2620', foreground: 'white' },
  212: { background: '#5A0C40', foreground: 'white' },
  220: { background: '#FF8000', foreground: 'black' },
  221: { background: '#994C00', foreground: 'white' },
  222: { background: '#331800', foreground: 'white' },
};

export const paletteKeys = () => {
  return _.keys(palette);
};

const baseKey = size => {
  return `CM • ${size} • `;
};

export const boardKey = size => {
  return `${baseKey(size)}BOARD`;
};

export const statsKey = size => {
  return `${baseKey(size)}STATS`;
};

export const getStats = (size, resolve) => {
  const key = statsKey(size);

  dbget(key, stats => {
    if (!stats) {
      stats = { plays: 0, aggScore: 0, bestScore: 0 };
    }

    resolve(stats);
  });
};

export const cellPos = i => {
  const row = Math.floor(i / COL_COUNT) + 1;
  const col = (i % COL_COUNT) + 1;

  return { row, col };
};

export const scoreFromSecs = (secs, size) => {
  const score = 1000 - ((secs || 0) * 100) / size;
  return score;
};

export const getGrade = (score, plays) => {
  return plays ? _.round((score * Math.min(10, plays)) / 10) : 0;
};
